import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import PrivateRouteAccessHOC from "./PrivateRouteAccessHOC";

const PrivateRoute = ({ Component }) => {
  const authToken = useSelector((state) => state.auth.user?.jwtToken);
  return authToken ? <Component /> : <Navigate to="/login" />;
};
export default PrivateRoute;
